import React from 'react';

function ActionPopUp(props) {
  const { setActionPopUp } = props;
  return (
    <div className="Active-popup-container">
      <p className="Confirm-text">Delete</p>
      <p className="Save-active-text">Are you sure want to delete</p>
      <div className="active-popup-button">
        <button
          className="active-cancel-button"
          type="button"
          onClick={() => setActionPopUp(false)}
        >
          Cancel
        </button>
        <button
          className="active-confirm-button"
          type="button"
          onClick={() => setActionPopUp(false)}
        >
          Confirm
        </button>
      </div>
    </div>
  );
}

export default ActionPopUp;
